import React from "react";
import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import style from "./index.module.scss";
import { EndExerciseStuInfo } from "service/exercise";

interface TipStuListProps {
    children: React.ReactNode;
    placement?: TooltipPlacement;
    stuList: EndExerciseStuInfo[];
}

export default function TipStuList({
    stuList,
    children,
    placement = "bottomLeft"
}: TipStuListProps) {
    const overlay = (
        <div className={style.root}>
            {stuList.map(item => (
                <div key={item.studentId} className={style.item}>
                    <span>{item.stuName}</span>
                    <span className={style.num}>{item.studentId}</span>
                </div>
            ))}
        </div>
    );

    function getContainer(): any {
        return document.querySelector(".ExerciseContainer");
    }

    return (
        <Tooltip
            getPopupContainer={getContainer}
            overlay={stuList.length !== 0 && overlay}
            placement={placement}
            className={style.root}
            overlayClassName={style.overlay}>
            {children}
        </Tooltip>
    );
}
